














import { Vue, Component, Prop } from "vue-property-decorator";

export type InputType = "radio" | "checkbox";

@Component
export default class BinaryInput extends Vue {
  @Prop({
    type: String,
    required: false,
    default: () => Math.random().toString()
  })
  id!: string;
  @Prop({ type: Boolean, required: false, default: false }) value!: boolean;
  @Prop({ type: String, required: false, default: "binary input" })
  label!: string;
  @Prop({ type: String, required: false, default: "checkbox" })
  type!: InputType;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;

  send() {
    // ラジオボタンの場合、すでに選択されていたら何もしない
    if (this.type === "radio" && this.value) {
      return;
    }

    // disabledである場合、現在の値を変更せず送って終了
    if (this.disabled) {
      this.$emit("input", this.value);
      return;
    }

    // 新しい値を送る
    this.$emit("input", !this.value);
  }
}
